var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_15205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4168 8.66683V5.41683C18.4168 5.12951 18.3027 4.85396 18.0995 4.6508C17.8964 4.44763 17.6208 4.3335 17.3335 4.3335H6.50016C5.92553 4.3335 5.37443 4.56177 4.9681 4.9681C4.56177 5.37443 4.3335 5.92553 4.3335 6.50016M4.3335 6.50016C4.3335 7.0748 4.56177 7.6259 4.9681 8.03223C5.37443 8.43856 5.92553 8.66683 6.50016 8.66683H19.5002C19.7875 8.66683 20.063 8.78097 20.2662 8.98413C20.4694 9.18729 20.5835 9.46284 20.5835 9.75016V13.0002M4.3335 6.50016V19.5002C4.3335 20.0748 4.56177 20.6259 4.9681 21.0322C5.37443 21.4386 5.92553 21.6668 6.50016 21.6668H19.5002C19.7875 21.6668 20.063 21.5527 20.2662 21.3495C20.4694 21.1464 20.5835 20.8708 20.5835 20.5835V17.3335",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 13V17.3333H17.3332C16.7585 17.3333 16.2074 17.1051 15.8011 16.6987C15.3948 16.2924 15.1665 15.7413 15.1665 15.1667C15.1665 14.592 15.3948 14.0409 15.8011 13.6346C16.2074 13.2283 16.7585 13 17.3332 13H21.6665Z",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_15205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPaymentIcon);
export default __webpack_public_path__ + "static/media/AccountPaymentIcon.01c593708bad8198be499c7b39250d49.svg";
export { ForwardRef as ReactComponent };